import * as $ from 'jquery';

export class Wizard {
    private step1: JQuery;
    private step2: JQuery;
    private step3: JQuery;
    private loading: JQuery;
    private restart: JQuery;
    private ticketArea: JQuery;
    private pickEmployeeArea: JQuery;
    private pickPhoneNumberArea: JQuery;
    private wizardNext: JQuery;
    private wizardPrev: JQuery;
    private pickEmployees: JQuery;
    private pickRecipientTypeArea: JQuery;

    constructor(private container: JQuery) {
        this.step1 = container.find('.step--1');
        this.step2 = container.find('.step--2');
        this.step3 = container.find('.step--3');
        this.loading = container.find('.loading');
        this.restart = container.find('.restart');

        // step 1 - steps
        this.ticketArea = container.find('.ticket-type-area');
        this.pickEmployeeArea = container.find('.pick-employee-area');
        this.pickPhoneNumberArea = container.find('.pick-phone-number-area');
        this.pickRecipientTypeArea = container.find('.pick-recipient-type-area');

        this.wizardNext = container.find('.wizard-next');
        this.wizardPrev = container.find('.wizard-previous');
        this.pickEmployees = container.find('.picked-ticket-type-next');

        this.initialize();
    }

    private initialize() {
        this.wizardNext.on('click', (evt) => this.next());
        this.wizardPrev.on('click', (evt) => this.prev());
        this.pickEmployees.on('click', (evt) => this.showEmployees());
    }

    private next() {
        this.step1.hide();
        this.step2.show();
    }

    private prev() {
        this.step2.hide();
        this.step1.show();
    }

    public showOrderConfirmation() {
        this.step1.hide();
        this.step2.hide();
        this.loading.hide();
        this.step3.show();
    }

    public showLoading() {
        this.step1.hide();
        this.step2.hide();
        this.loading.show();
        this.step3.hide();
    }

    public showEmployees() {
        this.pickRecipientTypeArea.show();
        this.ticketArea.addClass('minimize');
        $('#Manual-Row-1 #ManualPhoneInput').focus();
    }

    public showNumberSelection() {
        this.pickRecipientTypeArea.hide();
        this.next();
    }

    public reset() {
        this.pickRecipientTypeArea.hide();
        this.ticketArea.removeClass('minimize');
        this.prev();
    }

    public showRestart() {
        this.loading.hide();
        this.restart.show();
    }
}
